import React from 'react';
import { Trans } from 'react-i18next';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { translit1 } from '../../../components/common';
import { useLanguage } from '../../../hooks';
import NoCover from '../../../img/no-cover.svg';
import { MediaUnit } from '../../../services/content_v1';

interface WelcomeVerticalContentProps {
    title: string,
    items: MediaUnit[]
}

const WelcomeVerticalContent: React.FC<WelcomeVerticalContentProps> = ({ title, items }) => {
    const lang = useLanguage()
    const type = 'media';

    return (items.length || 0) > 0 && (
        <section className="welcome-section">
            <div className="welcome-section__back"></div>
            <div className="welcome-section__body">
                <section className="welcome-content _vertical">
                    <header className="welcome-header">
                        <h2 className="welcome-header__heading">
                            <a href={`/${lang}/public-showcase/${'media?vertical=true'}`}>
                                {title}
                                <LinkTo />
                            </a>
                        </h2>
                        <div className="welcome-header__link">
                            <a href={`/${lang}/public-showcase/${'media?vertical=true'}`}>
                                <Trans>See all</Trans>
                                <LinkTo />
                            </a>
                        </div>
                    </header>

                    <div className="welcome-content__list">
                        {items.map((item, index) => (
                            <div key={index} className="welcome-content__list-item">
                                <article className="welcome-content__item">
                                    <div className="welcome-content__item-image">
                                        {item.covers?.at(0) ?
                                            // <ImageLoader url={item.covers?.at(0)} alt="" />
                                            <img src={item.covers?.at(0)} alt="" decoding="async" loading="lazy" style={{ objectFit: 'cover'}} />
                                            :
                                            <img src={NoCover} alt="" />
                                        }
                                    </div>
                                    <div className="welcome-content__item-name">
                                        <a href={`/${lang}/public-showcase/${type}/${item.id}_${translit1(item.title) || '_'}`}>{item.title}</a>
                                    </div>
                                </article>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </section>
    );
};

export default WelcomeVerticalContent;